import { css } from '@emotion/react';
import styled from '@emotion/styled';
import FlexStack from '../FlexStack/FlexStack';

interface CharacterCardProps {
  width?: number;
  height?: number;
}

export default function CharacterCard({ width, height }: CharacterCardProps) {
  return (
    <Container width={width}>
      <Image height={height} />
    </Container>
  );
}

const Container = styled(FlexStack)<CharacterCardProps>`
  ${({ width }) => css`
    flex-shrink: 0;
    width: ${width ? `${width}px` : '100%'};
    min-height: 185px;
  `}
`;

const Image = styled.div<{ height?: number }>`
  ${({ theme, height }) => css`
    width: 100%;
    height: ${height ? `${height}px` : '100%'};
    background-color: ${theme.backgroundColor.bg_dark_2};
    ${theme.mixins.aspectRatio.ratio3_4};
  `}
`;
